import Button from '@material-ui/core/Button';
import ExpansionPanel from '@material-ui/core/ExpansionPanel';
import ExpansionPanelDetails from '@material-ui/core/ExpansionPanelDetails';
import ExpansionPanelSummary from '@material-ui/core/ExpansionPanelSummary';
import Typography from '@material-ui/core/Typography';
import ExpandMoreIcon from '@material-ui/icons/ExpandMore';
import React, { Component } from 'react';
import { connect } from 'react-redux';
import { bindActionCreators, Dispatch } from 'redux';
import Footer from '~/components/Footer';
import { ApplicationState, store } from '~/store';
import { multipleLanguageRequest } from '~/store/ducks/language/actions';
import { setThemeRequest } from '~/store/ducks/theme/actions';
import { Container, Content, Header } from './styles';

const dataFAQ = [
  {
    title: 'Quais são os dados pessoais coletados pela SKY?',
    content: [
      `Desde que estritamente necessário, a SKY coleta os dados que você
      nos fornece no momento da aquisição de nossos serviços e produtos, tais como
      nome, endereço, telefone, e-mail, informações bancárias, entre outras.`,

      `Além disso, quando você utiliza os serviços e plataformas oferecidos pela SKY
      para fazer compras, por exemplo, algumas informações sobre a transação e/ou dados
      associados a ela podem ser coletadas, tais como o valor pago e o meio de pagamento utilizado.`,

      `Certas informações também podem ser coletadas quando você entra em contato
      com a SKY, seja através do Serviço de Atendimento ao Consumidor (SAC) ou qualquer
      outro canal de atendimento, sempre no contexto da prestação dos serviços por você
      contratados. `,

      `A SKY também pode receber informações sobre você vindas de terceiros que
       nos permitam, por exemplo, implementar medidas antifraude e de proteção ao crédito.`,

      `Caso utilize as plataformas on-line da SKY, também poderão ser coletados
       cookies, um recurso padrão encontrado em seu navegador de Internet
       (Ex.: Explorer, Chrome, Firefox, Safari etc.). Os cookies registram a navegação
       em nossa plataforma e identificam o equipamento utilizado, registrando padrões de
       navegação e facilitando e agilizando o preenchimento de formulários. `,
    ],
    id: 1,
  },
  {
    title: 'Como a SKY usa meus dados pessoais?',
    content: [
      `A SKY utilizará as informações coletadas para viabilizar a prestação e
      boa fruição dos serviços que você adquirir. Adicionalmente, a SKY utilizará
      essas informações para constantemente aprimorar seus serviços e produtos.`,

      `A SKY também utilizará esses dados para permitir o bom funcionamento de
      suas plataformas digitais e canais de atendimento, bem como para lhe oferecer
      ofertas especiais e benefícios, caso aplicáveis. Além disso, a SKY poderá usar
      essas informações para viabilizar o processamento e envio de avisos de transações,
      o gerenciamento de riscos, o fornecimento de proteção ao crédito e/ou a
      implementação de medidas antifraude.`,
    ],
    id: 2,
  },
  {
    title: 'A SKY compartilha meus dados pessoais?',
    content: [
      `A SKY poderá compartilhar suas informações com as demais
      empresas que fazem parte do grupo SKY e suas empresas controladoras,
      coligadas e subsidiárias.`,

      `Adicionalmente, a SKY poderá compartilhar seus dados com terceiros,
      sempre respeitando a legislação. Em regra, esse compartilhamento ocorrerá
      quando necessário para viabilizar a prestação de serviços SKY ou para o
      cumprimento de obrigações legais e/ou regulatórias aplicáveis.`,

      `Por fim, a SKY poderá armazenar seus dados em sistemas de “nuvens” ou
      outras infraestruturas e tecnologias similares. Portanto, seus dados pessoais
      poderão ser tratados em outros países, tais como os Estados Unidos da América,
      sempre respeitando a legislação vigente aplicável. `,
    ],
    id: 3,
  },
  {
    title: 'Como posso controlar meus dados pessoais?',
    content: [
      `A SKY está comprometida em garantir a proteção de todos os seus direitos
      previstos nas legislações sobre privacidade e proteção de dados em vigor,
      incluindo, mas não se limitando, ao direito de acesso, de retificação, de
      anonimização, de bloqueio ou de eliminação de seus dados pessoais, bem como
      de solicitar informações sobre as entidades públicas e privadas com as quais
      a SKY compartilhou seus dados e/ou a revogação de eventual consentimento
      fornecido à prestadora e suas consequências, quando assim aplicável.`,

      `Para exercer estes e outros direitos relacionados, pedimos que encaminhe
      sua solicitação através do e-mail indicado ao final deste Termo ou que acesse o site`,
    ],
    id: 4,
  },
  {
    title: 'Quais medidas de segurança são implementadas pela SKY?',
    content: [
      `A SKY mantém medidas atualizadas de segurança técnicas, físicas e
      administrativas projetadas especialmente para o fornecimento de proteção
      necessária contra perda, divulgação, alteração e quaisquer outras violações
      aos seus dados pessoais. `,

      `Você pode nos ajudar a cuidar de sua segurança on-line evitando acessar
      sites suspeitos e baixar arquivos de origem desconhecida, mantendo seu sistema
      operacional sempre atualizado, utilizando programas de segurança (antivírus e
        firewall, por exemplo) e escolhendo senhas complexas e não as fornecendo para terceiros. `,

      `Além disso, a SKY nunca solicitará que você revele sua senha. Se receber
        qualquer mensagem nesse sentido, por favor a informe à SKY e não a revele a
        terceiros em nenhuma hipótese. Se, por qualquer motivo, tiver fornecido sua
        senha a terceiros, pedimos que a altere imediatamente. Da mesma maneira,
        pedimos que altere sua senha caso suspeite que terceiros possam ter acesso
        a ela ou note movimentações estranhas relacionadas ao seu uso dos serviços,
        produtos ou plataformas SKY.`,
    ],
    id: 5,
  },
];

interface StateProps {
  user: any;
  language: any;
}

interface DispatchProps {
  multipleLanguageRequest(language: string): void;
  setThemeRequest(): void;
}

type Props = StateProps & DispatchProps;

class SignIn extends Component<Props> {
  state = {};

  componentDidMount() {
    const { multipleLanguageRequest } = this.props;
    multipleLanguageRequest('ptbr');

    document.title = 'Fazer logon';
  }

  render() {
    const { signed } = store.getState().auth;

    return (
      <Container>
        <Header>
          <div className="content-header-faq">
            <div className="logo">Vrio</div>
            <div className="login">
              {signed ? (
                <a href="/home">
                  <Button>Voltar ao menu principal</Button>
                </a>
              ) : (
                <a href="/">
                  <Button>Fazer login</Button>
                </a>
              )}
            </div>
          </div>
        </Header>
        <Content>
          <div className="content-header">
            <h1>FAQ</h1>
            <h4>Perguntas mais frequentes</h4>
          </div>

          <div className="faq-question-fix">
            <h3>Privacidade de dados - FAQ</h3>
            <p>
              A privacidade dos dados pessoais de clientes e parceiros é uma das
              prioridades da SKY. Por isso, empregamos técnicas modernas de
              segurança da informação para manter seus dados seguros e
              oferecemos ferramentas que permitem que você controle como seus
              dados serão utilizados.
            </p>

            <p>
              A SKY também acompanha as evoluções na legislação e nas regulações
              sobre privacidade de dados, para assegurar que você possa exercer
              todos os direitos sobre seus dados pessoais.
            </p>

            <p>
              A manutenção da confiança dos clientes é um compromisso contínuo.
              Portanto, pedimos que analise detalhadamente nossa Política de
              Privacidade antes de adquirir nossos produtos ou serviços, para
              fique ciente da maneira como nós tratamos e protegemos as suas
              informações. Em todo caso, esclarecemos, desde já, que garantimos:
            </p>
            <ul>
              <li>Respeitar a titularidade dos seus dados pessoais;</li>
              <li>
                Solicitar seu consentimento, sempre que necessário e aplicável,
                para a realização de atividades de tratamento de seus dados
                pessoais não previstas em nossa Política de Privacidade;
              </li>
              <li>
                Permitir que você controle e corrija seus dados pessoais,
                através de nosso Portal de Privacidade.
              </li>
            </ul>

            <p>
              Abaixo seguem as perguntas mais frequentes sobre nossa Política de
              Privacidade:
            </p>
          </div>

          <div className="faq-question">
            {dataFAQ.map(el => (
              <ExpansionPanel key={el.id}>
                <ExpansionPanelSummary
                  expandIcon={<ExpandMoreIcon />}
                  aria-controls="panel1a-content"
                  id="panel1a-header"
                >
                  <Typography className="title">{el.title}</Typography>
                </ExpansionPanelSummary>
                <ExpansionPanelDetails>
                  <ul>
                    {el.content.map((content, index) => (
                      <li key={index}>{content}</li>
                    ))}
                  </ul>
                </ExpansionPanelDetails>
              </ExpansionPanel>
            ))}
          </div>
        </Content>
        <Footer />
      </Container>
    );
  }
}

const mapStateToProps = (state: ApplicationState) => ({
  user: state.user.profile,
  language: state.language.data,
});

const mapDispatchToProps = (dispatch: Dispatch) => ({
  ...bindActionCreators({ multipleLanguageRequest, setThemeRequest }, dispatch),
});

export default connect(mapStateToProps, mapDispatchToProps)(SignIn);
